(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.slickSlider = {
    attach: function (context, settings) {
      // Handle ScrollReveal initialization on carousel init
      $('.l-events-carousel', context).on('init', function (event, slick) {
        var slideUp = {
          distance: '30px',
          origin: 'bottom',
          opacity: 0,
          delay: 0,
          duration: 700,
          easing: 'cubic-bezier(0.6, 0, 0.4, 0.6)',
          interval: 100,
        };
        var fadeIn = {
          opacity: 0,
          delay: 0,
          duration: 700,
          easing: 'cubic-bezier(0.6, 0, 0.4, 0.6)',
        };

        // Apply ScrollReveal animations
        ScrollReveal().reveal(
          '.field h1, .field h2, .field h3, .field h4',
          slideUp,
        );
        ScrollReveal().reveal(
          '.field .field--name-field-title, .field .section-link__link',
          slideUp,
        );
        ScrollReveal().reveal('.field img', fadeIn);
        ScrollReveal().reveal(
          '.inner-research-link, .field .button--primary',
          slideUp,
        );
        ScrollReveal().reveal(
          '.l-staff-featured-body a, .field select',
          slideUp,
        );
        ScrollReveal().reveal('.field p, .field ul li', slideUp);
        ScrollReveal().reveal('.field .field--name-field-subtitle', slideUp);
        ScrollReveal().reveal('.l-resources-card-header', slideUp);
        ScrollReveal().clean('.l-events-title');
        ScrollReveal().reveal('.l-events-title, .l-events-eyebrow', slideUp);
        ScrollReveal().reveal('.field--name-field-column-one-header', slideUp);
        ScrollReveal().reveal(
          '.l-quote blockquote, .l-careers-video-inner',
          slideUp,
        );
        ScrollReveal().reveal('.l-careers-video-link', slideUp);
        ScrollReveal().reveal(
          '.l-careers-header a, .l-careers-header h2',
          slideUp,
        );

        // Clean up various elements
        const elementsToClean = [
          '.l-quote blockquote p',
          '.field--name-field-research-area-paragraphs p',
          '.field--name-field-research-area-paragraphs img',
          '.l-header img, .l-header h2, .l-header h3, .l-header p',
          '.l-header .section-link__link',
          '.l-header .field--name-field-title',
          '.l-header .button--primary',
          '.l-header .l-quote blockquote',
          '.l-header .l-resources-card-header',
          '.l-header .l-events-eyebrow',
          '.l-header .field--name-field-featured-image',
          '.l-header .l-resources-card-body',
          '.home-hero-info-container .home-hero-title',
          '.home-hero-info-container .field--name-field-title',
          '.home-hero-info-container p',
          '.home-hero-info-container .button--primary',
          '.breadcrumb ul li',
          '.field--name-field-subtitle',
          '.l-resources-column-categories p',
          '.event__see-more-content p',
          '.l-resources .l-resources-card-body p',
          '.block-views-blockresources-listingtwo-resourceslisting .node--page h2',
          '.bio--teaser__position',
          '.bio--teaser__division',
          '.bio--teaser__title',
          '.node--bio-page--full .sidebar__departments ul li'
        ];

        elementsToClean.forEach((selector) => {
          ScrollReveal().clean(selector);
        });
      });

      // Initialize events carousel
      once('slickSlider', '.l-events-carousel', context).forEach(function (
        element,
      ) {
        $(element).slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
                dots: true,
                slidesToShow: 1,
              },
            },
          ],
        });
      });

      // Initialize careers carousel
      once('slickSlider', '.l-careers-inner', context).forEach(function (
        element,
      ) {
        $(element).slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    },
  };
})(jQuery, Drupal, once);
